import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.5 6.45825H2.5C2.15833 6.45825 1.875 6.17492 1.875 5.83325C1.875 5.49159 2.15833 5.20825 2.5 5.20825H17.5C17.8417 5.20825 18.125 5.49159 18.125 5.83325C18.125 6.17492 17.8417 6.45825 17.5 6.45825Z",
      fill: "black"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.5 10.625H2.5C2.15833 10.625 1.875 10.3417 1.875 10C1.875 9.65833 2.15833 9.375 2.5 9.375H17.5C17.8417 9.375 18.125 9.65833 18.125 10C18.125 10.3417 17.8417 10.625 17.5 10.625Z",
      fill: "black"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.5 14.7917H2.5C2.15833 14.7917 1.875 14.5084 1.875 14.1667C1.875 13.8251 2.15833 13.5417 2.5 13.5417H17.5C17.8417 13.5417 18.125 13.8251 18.125 14.1667C18.125 14.5084 17.8417 14.7917 17.5 14.7917Z",
      fill: "black"
    }, null, -1)
  ])))
}
export default { render: render }